import { render } from "./Spinner.html?vue&type=template&id=b313d92c&scoped=true&ts=true&external"
import script from "./Spinner.ts?vue&type=script&lang=ts&external"
export * from "./Spinner.ts?vue&type=script&lang=ts&external"

import "./Spinner.scss?vue&type=style&index=0&id=b313d92c&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b313d92c"]])

export default __exports__